"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.IH265TranscoderDispatch = exports.IH265TranscoderObserver = void 0;
const native_rtc_1 = require("@iris/native-rtc");
const AgoraConsole_1 = require("../util/AgoraConsole");
class IH265TranscoderObserver {
    constructor(engine) {
        this._engine = engine;
    }
    notifyEvent(param) {
        this._engine.irisEventHandlerManager.notifyEvent('RtcEngine', param);
    }
    onEnableTranscode_6ba6646(result) {
        AgoraConsole_1.AgoraConsole.warn('H265TranscoderObserver_onEnableTranscode_6ba6646 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onQueryChannel_31ba3df(result, originChannel, transcodeChannel) {
        AgoraConsole_1.AgoraConsole.warn('H265TranscoderObserver_onQueryChannel_31ba3df not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onTriggerTranscode_6ba6646(result) {
        AgoraConsole_1.AgoraConsole.warn('H265TranscoderObserver_onTriggerTranscode_6ba6646 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IH265TranscoderObserver = IH265TranscoderObserver;
class IH265TranscoderDispatch {
    constructor(engine) {
        this._engine = engine;
    }
    // @ts-ignore
    enableTranscode_a0779eb(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('H265Transcoder_enableTranscode_a0779eb not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    queryChannel_a0779eb(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('H265Transcoder_queryChannel_a0779eb not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    triggerTranscode_a0779eb(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('H265Transcoder_triggerTranscode_a0779eb not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    registerTranscoderObserver_e1ee996(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('H265Transcoder_registerTranscoderObserver_e1ee996 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    unregisterTranscoderObserver_e1ee996(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('H265Transcoder_unregisterTranscoderObserver_e1ee996 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IH265TranscoderDispatch = IH265TranscoderDispatch;
